export default __webpack_public_path__ + "static/media/cross.bbdfde10.svg";